const ProjectAuthenticationTypes = Object.freeze({
  NONE: "N",
  BASIC: "B",
  BEARER: "J",
  CUSTOM: "C",
});

export default ProjectAuthenticationTypes;
